import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DemoEnvironmentBanner from 'components/DemoEnvironmentBanner';
import Logo from 'components/Logo';
import { LoginForm } from 'components/authentication/login';
import Page from 'components/Page';
import AuthLayout from 'layouts/AuthLayout';
import { Link as RouterLink } from 'react-router-dom';
import { PATH_PAGE } from 'routes/paths';
import { isDemoMode } from 'utils/demoEnvironment';

const RootStyle = styled(Page)({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
});

const MainStyle = styled(Container)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(6),
}));

export default function Login() {
  const demo = isDemoMode();

  return (
    <RootStyle title={demo ? 'Mobeat demo' : 'Login'}>
      <DemoEnvironmentBanner />

      {!demo && (
        <AuthLayout>
          Need access?&nbsp;
          <Link underline='none' variant='subtitle2' component={RouterLink} to={PATH_PAGE.requestDemo}>
            Request a demo
          </Link>
        </AuthLayout>
      )}

      <MainStyle maxWidth='sm'>
        <Box sx={{ width: '100%', maxWidth: 420 }}>
          {demo ? (
            <Stack alignItems='center' spacing={2} sx={{ mb: 4 }}>
              <Logo />
              <Typography variant='h4' textAlign='center'>
                Sign in to Mobeat demo
              </Typography>
              <Typography variant='body2' color='text.secondary' textAlign='center'>
                Use the credentials Mobeat sent you. Everyone shares the same sample charts.
              </Typography>
            </Stack>
          ) : (
            <Typography variant='h4' gutterBottom sx={{ mb: 4 }}>
              Sign in
            </Typography>
          )}

          <LoginForm />
        </Box>
      </MainStyle>
    </RootStyle>
  );
}
